// extracted by mini-css-extract-plugin
export default {"path":"_3MvgliBN_D","dash":"_2C1TpO8LMn"};